import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  title: {
    fontWeight: '600',
    fontSize: 20,
    lineHeight: 48,
    color: '#003353',
  },
  input: {
    backgroundColor: '#FFF',
    marginTop: 0,
  },
  textStyle: {
    height: 36,
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '400',
  },
  mb: { marginBottom: 8 },
  amountInput: {
    height: 52,
    minHeight: 52,
    backgroundColor: '#FFF',
    width: '100%',
    margin: 0,
    paddingLeft: 13,
  },
  addToProjectText: {
    fontSize: 20,
    fontWeight: '500',
    color: '#003353',
    marginTop: 8,
    lineHeight: 30,
    marginBottom: 24,
  },
})
